<template>
  <div class="header-full">
    <cnd-icon
      :name="isFull ? 'cnd-fullScreen-close' : 'cnd-fullScreen'"
      @click="handleFullScreen"
    />
  </div>
</template>

<script>
import screenfull from 'screenfull'
import { MessageUtil } from '@cndinfo/cube-web-utils'

export default {
  name: 'HeaderFull',
  data() {
    return {
      isFull: false
    }
  },
  mounted() {
    // this.init()
  },
  beforeDestroy() {
    this.destroy()
  },
  created() {
    screenfull.on('change', () => {
      console.log('当前是否是全屏', screenfull.isFullscreen)
      this.isFull = screenfull.isFullscreen
    })
  },
  methods: {
    handleFullScreen() {
      if (!screenfull.isEnabled) {
        MessageUtil.warning(this.$t('grid.tips.currentBrowserIsNotSupported'))
        return false
      }
      screenfull.toggle()
      this.isFull = !this.isFull
    }
    // change() {
    //   console.log('screenfull', screenfull)
    //   this.isFull = screenfull.isFullScreen
    // },
    // init() {
    //   console.log('screenfull.isEnabled', screenfull.isEnabled)
    //   if (screenfull.isEnabled) {
    //     screenfull.on('change', this.change)
    //   }
    // },
    // destroy() {
    //   if (screenfull.isEnabled) {
    //     screenfull.off('change', this.change)
    //   }
    // }
  }
}
</script>
